module.exports = __webpack_public_path__ + "img/34t.c4f5b84f.jpg";